import { Button, ButtonType } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ValidatedField } from "@components/ValidatedField";
import { useTranslation } from "@i18n/hooks";
import { inputFieldClass } from "./select-multiple-accounts-form.styles";
import {
	SelectMultipleAccountsFormProps,
	SelectMultipleAccountsFormState,
} from "./select-multiple-accounts-form.types";
import { SelectMultipleAccountsField } from "../select-multiple-accounts-field/select-multiple-accounts-field.component";
import { SelectMultipleAccountsFieldState } from "../select-multiple-accounts-field/select-multiple-accounts-field.types";

export const SelectMultipleAccountsForm = ({
	onAccountSelected,
	disabled,
}: SelectMultipleAccountsFormProps) => {
	const { t } = useTranslation(["common", "validation"]);
	const formik = useFormik<SelectMultipleAccountsFormState>({
		initialValues: {},
		validationSchema: Yup.object().shape({
			accounts: Yup.array()
				.of(
					Yup.object().shape({
						id: Yup.string(),
						name: Yup.string(),
					}),
				)
				.min(1, t("validation:accountRequired"))
				.required(t("validation:selectAtLeastOneAccount")),
		}),
		onSubmit: (data, { setSubmitting }) => {
			onAccountSelected(data.accounts!.map((account) => account.id!));
			setSubmitting(false);
		},
	});

	return (
		<form onSubmit={formik.handleSubmit}>
			<ValidatedField<SelectMultipleAccountsFormState, SelectMultipleAccountsFieldState>
				className={inputFieldClass}
				name={"accounts"}
				label={t("common:account.selectAccount")}
				formikConfig={formik}
				component={(renderConfig) => <SelectMultipleAccountsField {...renderConfig} />}
			/>
			<Button
				disabled={!formik.isValid || disabled}
				label={t("common:account.addAccount")}
				type={ButtonType.Submit}
			/>
		</form>
	);
};
